export const opacities = {
    light12: 0.12,
    light24: 0.24,
    light38: 0.38,
    halfOpacity: 0.5,
    dark70: 0.7,
    dark87: 0.87,
    noOpacity: 1.0,
    rgbaLight04: 'rgba(0, 0, 0, 0.04)',
    rgbaLight08: 'rgba(0, 0, 0, 0.08)',
    rgbaLight10: 'rgba(0, 0, 0, 0.1)',
    rgbaLight12: 'rgba(0, 0, 0, 0.12)',
    rgbaLight14: 'rgba(0, 0, 0, 0.14)',
    rgbaLight15: 'rgba(0, 0, 0, 0.15)',
    rgbaLight20: 'rgba(0, 0, 0, 0.2)',
    rgbaHalfOpacity: 'rgba(0, 0, 0, 0.5)'
};
/**
 * all font-sizes should be in pixel values
 */
export const fontSizes = {
    small: 12,
    root: 16,
    medium: 20,
    large: 24,
    xLarge: 28,
    xxLarge: 32,
    xxxLarge: 44
};
export const lineHeights = {
    root: 1.5,
    large: 1.57,
    larger: 1.6,
    largest: 1.67
};
export const fontWeights = {
    light: 300,
    regular: 400,
    semiBold: 600,
    bold: 700,
    extraBold: 800
};
// Spacing pixel values
export const spacing = {
    base: 16,
    xsmall: 4,
    small: 8,
    medium: 12,
    large: 24,
    xlarge: 32,
    xxlarge: 40
};
export const spacingBreakpointUnits = {
    small: 0.5,
    medium: 0.75,
    huge: 1.25
};
export const spacingDebugColors = {
    inline: '#3FCD28',
    inset: 'rgba(250, 40, 197, .2)',
    stack: '#2E71EA'
};
// These are static status colors that the consumer should not modify
export const statusColors = {
    warning: {
        border: '#f0d675',
        icon: '#caa416',
        font: '#333333',
        background: '#fffaeb'
    },
    success: {
        border: '#9FC294',
        icon: '#3E8529',
        font: '#333333',
        background: '#f0f6ef'
    },
    info: {
        border: '#9AB2BF',
        icon: '#3C777C',
        font: '#333333',
        background: '#f0f3f5'
    },
    error: {
        border: '#E39A93',
        icon: '#C63527',
        font: '#333333',
        background: '#fcf4f3'
    }
};
// These are static notification bar colors that the consumer should not modify
export const notificationBar = {
    warning: {
        font: '#333333',
        background: '#fffaeb',
        badgeBackground: '#caa416'
    },
    success: {
        font: '#333333',
        background: '#E7F6E3',
        badgeBackground: '#2B5C1D'
    },
    info: {
        font: '#333333',
        background: '#EBF7FF',
        badgeBackground: '#34657F'
    },
    error: {
        font: '#333333',
        background: '#FCF4F3',
        badgeBackground: '#9E2A20'
    }
};
export const colors = {
    aliceBlue: '#EBF0F2',
    altoGrey: '#d4d4d4',
    black: '#333333',
    brightBlue: '#69a6c8',
    cadetBlue: '#9eb5c2',
    cyanBlue: '#34657f',
    darkRed: '#9E2A1F',
    darkGrey: '#4C4C4C',
    darkYellow: '#8A6C00',
    doveGray: '#666666',
    error: '#C63527',
    grey: '#cdcdcd',
    heavyGrey: '#9E9E9E',
    info: '#0072AD',
    lightBlue: '#e5f6ff',
    lighterGrey: '#f4f4f4',
    lightestGrey: '#F6F6F6',
    lightGrey: '#E0E0E0',
    mediumGrey: '#656565',
    mercury: '#e2e2e2',
    neutralGrey: '#F2F2F2',
    orange: '#d76b00',
    paleYellow: '#FFFAEB',
    pattensBlue: '#9AB2BF',
    silver: '#C0C0C0',
    steelGray: '#3B3C43',
    success: '#3E8529',
    syfYellow: '#FBC600',
    terracotta: '#9E2A20',
    turquoise: '#58A7AF',
    turquoiseLight: '#ACD3D7',
    turquoiseLightest: '#F1F8F8',
    warning: '#FEB600',
    white: '#FFFFFF',
    wildSand: '#f5f5f5'
};
// Colors that will be allowed to be modified by the consumer (themed)
export const consumerTheme = {
    link: '#34657F',
    icon: '#34657F',
    // The color used to alter the browser default focus color
    focus: '#34657F',
    // For dropdown hover states, table row hover, and selected item background
    hoverBackground: '#EEF6F7',
    languageSelector: '#34657F',
    // The colors used to set the default (html) body text color and body background color, not to be confused with the body typography element
    body: {
        background: 'linear-gradient(to bottom right, #274c60, #162c37)',
        backgroundAttachment: 'fixed',
        text: '#333333'
    },
    accordion: {
        borderColor: '#e2e2e2',
        headerBackgroundColor: '#ffffff',
        activeHeaderBackgroundColor: '#f5f5f5'
    },
    tooltip: {
        borderColor: colors.white,
        backgroundColor: colors.white,
        color: colors.steelGray
    },
    backToTop: {
        shadow: 'rgba(48, 57, 65, 0.2)',
        background: colors.white,
        icon: '#595B53',
        hover: {
            background: '#014990',
            icon: '#F6F8FA'
        },
        active: {
            background: '#595B53',
            icon: '#F6F8FA'
        }
    },
    button: {
        primary: {
            text: '#FFFFFF',
            hover: '#244759',
            background: '#34657F'
        },
        secondary: {
            hover: '#EBF0F2'
        },
        text: '#34657F',
        background: '#34657F' // sets bg and border
    },
    binart: {
        background: '#34657f',
        disableBackground: '#ebf0f2',
        disableBorderColor: '#9eb5c2'
    },
    field: {
        icon: '#34657F',
        focus: '#34657F',
        label: '#34657F'
    },
    checkbox: {
        background: '#34657F',
        font: '#FFFFFF'
    },
    chip: {
        hover: '#ebf0f2',
        text: '#333333',
        animated: '#34657F'
    },
    switch: {
        background: '#34657F'
    },
    radio: {
        border: '#34657F',
        background: '#34657F',
        inactiveBorder: '#656565',
        focusBackground: '#939496'
    },
    navigation: {
        activeTabText: '#34657F',
        activeTabBorder: '#34657F'
    },
    datepicker: {
        navIcon: '#515151',
        shadow: 'rgba(16,24,40,0.25)',
        disabled: '#E0E0E0',
        legend: {
            currentDate: '#34657f',
            selectedDate: {
                fill: '#34657f',
                border: '#34657f',
                text: '#ffffff'
            },
            dueDate: {
                fill: '#ffffff',
                border: '#34657f',
                text: '#34657f'
            },
            pastDueDate: {
                fill: '#ffffff',
                border: '#AA0F00',
                text: '#656565'
            },
            lateFeeDate: {
                fill: '#757575',
                border: '#757575',
                text: '#ffffff'
            }
        }
    },
    footer: {
        background: '#3B3C43',
        text: '#FFFFFF',
        link: '#FFFFFF'
    },
    header: {
        background: '#F6F6F6',
        text: '',
        border: '' // just dsecurity: headerDivider
    },
    progressStepBar: {
        fill: '#34657F',
        hover: '#D6E0E5',
        label: '#34657F'
    },
    systemNavigation: {
        background: '#ffffff'
    },
    modal: { background: '#ffffff', headerBackground: '#f6f6f6' },
    progressBar: {
        complete: '#3e8529',
        error: '#c63527',
        inProgress: '#0072ad',
        background: '#e9eaeb'
    },
    meter: {
        gradientStart: '#97cee4',
        gradientEnd: '#01212f',
        valueTextColor: '#34657f'
    }
};
//# sourceMappingURL=defaultTheme.js.map